import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "@/app/routes";
import { LoadingScreen } from "@/components/LoadingScreen";
import { useCurrentUser } from "@/features/auth/hooks";
import { roleAtLeast } from "@/features/auth/roles";
import type { Role } from "@/features/auth/types";

interface ProtectedAdminRouteProps {
  children: ReactNode;
  minimumRole?: Role;
}

export function ProtectedAdminRoute({ children, minimumRole = "EDITOR" }: ProtectedAdminRouteProps) {
  const location = useLocation();
  const currentUser = useCurrentUser();

  if (currentUser.isLoading || currentUser.isFetching) {
    return <LoadingScreen />;
  }

  if (!currentUser.data) {
    return <Navigate to={ROUTES.admin.login} replace state={{ from: location.pathname }} />;
  }

  if (!roleAtLeast(currentUser.data.role, minimumRole)) {
    return <Navigate to={ROUTES.admin.root} replace />;
  }

  return children;
}
